module.exports = __webpack_public_path__ + "img/pc-banner.fe2cdc57.png";